import { gql } from "@apollo/client";

import { confListElementFragment } from "./ConfListElementFragment";

export const confListFragment = gql`
  fragment ConfListFragment on FraudConfList {
    code
    name
    elements {
      ...ConfListElementFragment
    }
  }

  ${confListElementFragment}
`;
